import type { AuthSession } from '../auth/types';
import type { SessionUser } from '../api/monitor';

/**
 * Quem entrou, como o servidor registrou.
 *
 * Já não há chamada aqui: o `POST /auth/session` do login registra a pessoa
 * em `users` e devolve a linha — com a `role`, que é do SICOP e não da conta
 * Google — junto com o token de sessão. O que esta função faz é só expor essa
 * resposta, que viaja dentro da sessão guardada.
 */
export function useSessionUser(session: AuthSession | null): SessionUser | null {
  return session?.serverUser ?? null;
}
